module.exports = __webpack_public_path__ + "img/gercep-logo.d9c2449b.png";